// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2vuIE","buttons":"SendReceipts_buttons__1-B8v","email":"SendReceipts_email__2QMLT","bookApptTitle":"SendReceipts_bookApptTitle__1JRmT"};